import { render, staticRenderFns } from "./CatalogSections.vue?vue&type=template&id=1d0be8dc&scoped=true&"
import script from "./CatalogSections.vue?vue&type=script&lang=js&"
export * from "./CatalogSections.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSections.vue?vue&type=style&index=0&id=1d0be8dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0be8dc",
  null
  
)

export default component.exports